const featureSections = qsa(".feature")

featureSections.forEach(section => {
  const swiperEl = qs(".feature__slides", section)
  const controlEls = qsa(".feature__control", section)
  const numbersEl = qs('.feature__numbers', section)

  Object.assign(swiperEl, {
    slidesPerView: 1,
    breakpoints: {
      601:{
        slidesPerView: 2,
      },
      1081:{
        slidesPerView: 3,
      }
    }
  })
  
  swiperEl.initialize();
  
  controlEls.forEach((controlEl, i) => {
    controlEl.addEventListener('click', ()=> {
      if(i < 1){
        swiperEl.swiper.slidePrev()
      } else {
        swiperEl.swiper.slideNext()
      }
    })
  })

  function setNumbers(){
    const currentSlide = `${swiperEl.swiper.activeIndex + 1}`.padStart(2,'0')
    const totalSlides = `${swiperEl.swiper.slides.length - 1}`.toString().padStart(2,'0')
    numbersEl.replaceChildren(`${currentSlide} – ${totalSlides}`)
  }

  setNumbers()

  swiperEl.swiper.slides.forEach((slideEl, i)=>{
    const videoEl = qs('video', slideEl)
    if(videoEl){
      if(i === swiperEl.swiper.activeIndex){
        videoEl.play()
      } else {
        videoEl.pause()
      }
    }
  })
  
  swiperEl.addEventListener('slidechange', () => {
    setNumbers()
    if(swiperEl.swiper.activeIndex + 1 > swiperEl.swiper.slides.length - 2){
      swiperEl.swiper.allowSlideNext = false
    } else {
      swiperEl.swiper.allowSlideNext = true
    }
    swiperEl.swiper.slides.forEach((slideEl, i)=>{
      const videoEl = qs('video', slideEl)
      if(videoEl){
        if(i === swiperEl.swiper.activeIndex){
          videoEl.play()
        } else {
          videoEl.pause()
        }
      }
    })
  })
  
})